module.exports = "../images/hunting-activities-ear-falls-2@2x.jpg?v=3286778";